import React, { Fragment } from 'react';
import moment from 'moment-timezone';
import { DatePicker as FabricDatePicker } from 'office-ui-fabric-react/lib/DatePicker';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';

function renderFormattedDate(date) {
  return date.toString().toFormatedDateString();
}

const DatePicker = (props) => {
  const { label, tooltip, checked, ...rest } = props;

  const momentData = moment.localeData();

  const tooltipIcon = (
    <Fragment>
      {tooltip && (
        <span style={{ marginLeft: '0.5em' }}>
          <TooltipHost
            content={<span dangerouslySetInnerHTML={{ __html: tooltip }} />}
            id={this.hostId}
            calloutProps={{ gapSpace: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <Icon iconName="Info" />
          </TooltipHost>
        </span>
      )}
    </Fragment>
  );

  return (
    <FabricDatePicker
      label={
        <Fragment>
          {label}
          {tooltipIcon}
        </Fragment>
      }
      firstDayOfWeek={momentData.firstDayOfWeek()}
      formatDate={renderFormattedDate}
      strings={{
        months: momentData._months,
        shortMonths: momentData._monthsShort,
        days: momentData._weekdays,
        shortDays: momentData._weekdaysMin,
      }}
      showGoToToday={false}
      {...rest}
    />
  );
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/app/components/DatePicker/index.jsx